<form class="forms-sample d-flex" [formGroup]="form">
  <div class="col-4 pe-2">
    <ng-select class="custom" [items]="organizations$ | async" bindLabel="titleTh" bindValue="id"
               placeholder="กรุณาเลือก" formControlName="organizationId" [searchable]="true" [clearable]="true"
               [ngClass]="{'is-invalid': form.controls['organizationId'].touched && form.controls['organizationId'].invalid}"
               (change)="getDivisions(form.controls['organizationId']?.value)">
    </ng-select>
  </div>
  <div class="col-4 pe-2">
    <ng-select class="custom" [items]="divisions$ | async" bindLabel="titleTh" bindValue="id"
               placeholder="กรุณาเลือก" formControlName="divisionId" [searchable]="true" [clearable]="true"
               [ngClass]="{'is-invalid':form.controls['divisionId'].touched &&form.controls['divisionId'].invalid}"
               (change)="getSubdivisions(form.controls['divisionId']?.value)">
    </ng-select>
  </div>
  <div class="col-4 pe-2">
    <ng-select class="custom" [items]="subdivisions$ | async" bindLabel="titleTh" bindValue="id"
               placeholder="กรุณาเลือก" formControlName="subdivisionId" [searchable]="true" [clearable]="true"
               [ngClass]="{'is-invalid':form.controls['subdivisionId'].touched &&form.controls['subdivisionId'].invalid}"
               (change)="changeOrganize()">
    </ng-select>
  </div>
</form>
